import React, { FC } from 'react';
import * as MESSAGES from 'constants/messages';
import { PROFILE_FIELDS_MAX_LENGTH } from 'constants/profile';
import { ProfileFormRegister, ProfileFormValues } from 'types/profile';
import { TextInput } from 'components/atoms';
import { Field } from 'components/molecules';

type Value = {
  newGraduate: Pick<ProfileFormValues['newGraduate'], 'studyAbroadExperiences'>;
};

type CountryNameFormFieldProps = {
  register: ProfileFormRegister<Value>;
  index: number;
  defaultValue:
    | ProfileFormValues['newGraduate']['studyAbroadExperiences'][0]['countryName']
    | undefined;
};

const CountryNameFormField: FC<CountryNameFormFieldProps> = props => {
  const { register, index, defaultValue } = props;
  return (
    <Field
      label={
        MESSAGES.PROFILE.FIELD.NEW_GRADUATE_STUDY_ABROAD_EXPERIENCES
          .COUNTRY_NAME.LABEL
      }
    >
      <TextInput
        enterKeyHint="enter"
        name={`newGraduate.studyAbroadExperiences[${index}].countryName`}
        maxLength={
          PROFILE_FIELDS_MAX_LENGTH.NEW_GRADUATE_STUDY_ABROAD_EXPERIENCES_COUNTRY_NAME
        }
        aria-label={
          MESSAGES.PROFILE.FIELD.NEW_GRADUATE_STUDY_ABROAD_EXPERIENCES
            .COUNTRY_NAME.LABEL
        }
        ref={register()}
        defaultValue={defaultValue}
      />
    </Field>
  );
};

export default CountryNameFormField;
